const article_callout = () => {
  const selector = 'article_callout';
  const instances = document.querySelectorAll(`.${selector}`);

  const renderData = instance => {
    // Quotation marks
    const icon = document.createElement('img');
    icon.classList.add(`.${selector}-icon`);
    icon.src = instance.getAttribute('data-icon');
    icon.alt = 'Icon';
    instance.insertBefore(icon, instance.querySelector('*:first-child'));
  };

  // Loop through all components and output data
  instances.forEach(instance => renderData(instance));
};
article_callout();
